import { useEffect, useState } from "react";
import { app, authentication } from "@microsoft/teams-js";
import { Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Loader } from "@/components";
import styles from "@/pages/Auth/Auth.module.css";

const getAuthConfigError = (clientId: string, appResource: string) => {
  if (!clientId) return "Missing Microsoft Entra client ID";
  if (!appResource) return "Missing Microsoft Entra resource";
  return "";
};

const AuthStart = () => {
  const { t } = useTranslation();
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const clientId = process.env.REACT_APP_AAD_CLIENT_ID || "";
    const appResource = (process.env.REACT_APP_AAD_RESOURCE || "").replace(
      /\/+$/,
      "",
    );
    const currentOrigin = window.location.origin;
    const redirectUri = `${currentOrigin}/auth-end`;
    const configError = getAuthConfigError(clientId, appResource);

    if (configError) {
      setAuthError(configError);
      app
        .initialize()
        .then(() => {
          authentication.notifyFailure(configError);
        })
        .catch(() => undefined);
      return;
    }

    const scopes = `${appResource}/access_as_user openid profile email User.Read`;
    const state = Math.random().toString(36).substring(2);

    sessionStorage.setItem("auth_state", state);

    const authUrl =
      "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?" +
      `client_id=${encodeURIComponent(clientId)}` +
      "&response_type=token" +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=${encodeURIComponent(scopes)}` +
      `&state=${encodeURIComponent(state)}` +
      `&nonce=${Math.random().toString(36).substring(2)}` +
      "&response_mode=fragment";

    window.location.href = authUrl;
  }, []);

  if (!authError) return <Loader label={t("Authenticating...")} />;

  return (
    <div className={styles.container}>
      <Text size={400} className={styles.error}>
        {authError}
      </Text>
    </div>
  );
};

export default AuthStart;
